export const MATCHING_ORDER_STATUS_OPTIONS = [
  { label: '全部', value: '' },
  { label: '接单中', value: 2 },
  { label: '待支付', value: 3 },
  { label: '待确认', value: 4 },
  { label: '已完成', value: 5 },
  { label: '已取消', value: 6 },
]

export const MATCHING_ORDER_RECORD_TYPES = [
  { value: 1, label: '创建订单' },
  { value: 2, label: '修改订单' },
  { value: 3, label: '取消订单' },
  { value: 4, label: '成功接单' },
  { value: 5, label: '取消接单' },
  { value: 6, label: '自动取消' },
  { value: 7, label: '提交师资' },
  { value: 8, label: '订单支付' },
  { value: 9, label: '确认师资' },
  { value: 10, label: '自动确认' },
  { value: 11, label: '驳回师资' },
  { value: 12, label: '订单完成' },
  { value: 13, label: '延时确认' },
  { value: 14, label: '客服消息' },
  { value: 15, label: '系统提示' },
  { value: 16, label: '订单刷新' },
  { value: 17, label: '留言' },
  { value: 18, label: '协助延时确认' },
  { value: 19, label: '取消确认' },
  { value: 20, label: '查看师资' },
]

export function hasValue(value) {
  return value !== undefined && value !== null && value !== ''
}

export function valueOrDash(value) {
  return hasValue(value) ? value : '--'
}

function parseObject(value) {
  if (!value) return {}
  if (typeof value === 'object' && !Array.isArray(value)) return value
  if (typeof value !== 'string') return {}
  try {
    const parsed = JSON.parse(value)
    return parsed && typeof parsed === 'object' && !Array.isArray(parsed) ? parsed : {}
  } catch (error) {
    return {}
  }
}

export function extendInfo(row) {
  return parseObject(row && row.extend_info_obj)
}

export function extendValue(row, key) {
  if (!row) return undefined
  const info = extendInfo(row)
  if (hasValue(info[key])) return info[key]
  const flattenedKey = `extend_info_${key}`
  if (hasValue(row[flattenedKey])) return row[flattenedKey]
  return undefined
}

function splitValues(value) {
  if (Array.isArray(value)) return value.filter(hasValue).map((item) => String(item).trim())
  if (!hasValue(value)) return []
  return String(value).split(/[,，]/).map((item) => item.trim()).filter(Boolean)
}

export function formatCodeNames(codesValue, namesValue) {
  const codes = splitValues(codesValue)
  const names = splitValues(namesValue)
  const length = Math.max(codes.length, names.length)
  if (!length) return '--'
  const result = []
  for (let index = 0; index < length; index += 1) {
    const code = codes[index]
    const name = names[index]
    if (code && name) result.push(`(${code})${name}`)
    else result.push(name || code)
  }
  return result.join('、')
}

export function orderSubjects(row) {
  return formatCodeNames(row && row.apply_subject_codes, row && row.apply_subject_names)
}

export function orderMajor(row) {
  if (!row) return '--'
  const name = row.apply_major_name
  const code = row.apply_major_code
  if (!hasValue(name) && !hasValue(code)) return '--'
  if (hasValue(name) && hasValue(code)) return `(${code})${name}`
  return valueOrDash(name || code)
}

export function demandItems(row) {
  if (!row) return []
  const items = []
  const directions = formatCodeNames(row.demand_direction_codes, row.demand_direction_names)
  if (directions !== '--') items.push(`考试方向仅限：${directions}`)
  if (hasValue(row.demand_max_hour_amount)) items.push(`研究生时薪不高于 ${row.demand_max_hour_amount} 元/小时`)

  const recruitYears = extendValue(row, 'demand_recruit_years')
  if (hasValue(recruitYears)) items.push(`研究生录取年份仅限：${recruitYears}年`)

  const gender = Number(extendValue(row, 'demand_gender'))
  if (gender === 1) items.push('研究生性别：学长')
  if (gender === 2) items.push('研究生性别：学姐')
  if (Number(row.demand_academy_major_status) === 1) items.push('研究生与学员为同一个学院专业')
  if (Number(extendValue(row, 'demand_trial_listen_status')) === 1) items.push('正式课程前需要安排一节试听课')
  if (Number(extendValue(row, 'demand_professional_experience_status')) === 1) items.push('需要有对应的专业课辅导经验')

  const firstRank = extendValue(row, 'demand_before_first_rank')
  if (hasValue(firstRank)) items.push(`初试总分排名在前 ${firstRank} 名`)
  const firstTotalScore = extendValue(row, 'demand_min_first_total_score')
  if (hasValue(firstTotalScore)) items.push(`初试总成绩不低于 ${firstTotalScore} 分`)
  const professionalScore = extendValue(row, 'demand_min_first_professional_score')
  if (hasValue(professionalScore)) items.push(`专业课成绩不低于 ${professionalScore} 分`)
  if (Number(row.demand_same_reference_book_status) === 1) items.push('允许其他院校研究生根据参考书或大纲辅导')
  if (hasValue(row.demand_extra_info)) items.push(`其他要求：${row.demand_extra_info}`)

  if (hasValue(row.exclude_year_teachers)) {
    const excluded = String(row.exclude_year_teachers).replace(/不限年份-/g, '').replace(/,/g, '、')
    if (excluded) items.push(`排除老师：${excluded}`)
  }
  return items
}

export function commissionInfo(row) {
  const rawBase = row && row.total_out_receiver_amount
  if (!hasValue(rawBase) || !Number.isFinite(Number(rawBase))) {
    return { amount: null, text: '--', note: '' }
  }
  const base = Number(rawBase)
  const rawSubsidy = row && row.company_user_supply_coupon_amount
  const subsidy = hasValue(rawSubsidy) && Number.isFinite(Number(rawSubsidy)) ? Number(rawSubsidy) : 0
  const singleEarnType = Number(extendValue(row, 'receiver_single_earn_type'))
  const isExclusive = singleEarnType === 1 || singleEarnType === 2
  const subsidyApplied = subsidy > 0 && !isExclusive
  const amount = base + (subsidyApplied ? subsidy : 0)
  let note = ''
  if (subsidyApplied) note = `含补贴 ¥${subsidy.toFixed(2)}`
  else if (isExclusive) note = '独享佣金，不叠加补贴'
  return { amount, text: `¥${amount.toFixed(2)}`, note }
}

function sameId(left, right) {
  return hasValue(left) && hasValue(right) && String(left) === String(right)
}

export function orderStatusMeta(row, userId) {
  const status = Number(row && row.status)
  const receiverId = row && row.receiver_company_user_ids_real
  const isCurrentReceiver = sameId(receiverId, userId)
  const senderName = `${(row && row.sender_company_area) || ''}${(row && row.sender_company_user_teacher_name) || ''}`

  if (hasValue(receiverId) && !isCurrentReceiver && status !== 6) {
    return { label: '被接单', type: 'info', tip: '此为历史接单，当前订单已经被其他人接单。' }
  }
  if (status === 1) return { label: '待接单', type: 'primary', tip: '此为历史接单，当前订单已重新释放。' }
  if (status === 2) return { label: '接单中', type: 'primary', tip: '请尽快提交师资信息，超时订单将被自动释放到订单大厅。' }
  if (status === 3) return { label: '待支付', type: 'danger', tip: '等待对方支付，仅支付后方可查看师资详情。' }
  if (status === 4) return { label: '待确认', type: 'warning', tip: `等待${senderName || '对方'}确认，超时将自动确认并结算。` }
  if (status === 5) return { label: '已完成', type: 'success', tip: '订单已完成。' }
  if (status === 6 && isCurrentReceiver) return { label: '已取消', type: 'info', tip: '发单人已取消订单。' }
  if (status === 6) return { label: '已取消', type: 'info', tip: '此为历史接单，当前订单已取消。' }
  return { label: `未知状态（${valueOrDash(row && row.status)}）`, type: 'info', tip: '暂未识别该订单状态。' }
}

export function orderReceiveTypeTags(row) {
  const result = []
  if (Number(row && row.order_reuse_status) === 1) {
    result.push({ label: '重启接单', type: 'warning' })
  }
  if (Number(row && row.receive_order_type) === 1) {
    result.push({ label: '预留接单', type: 'success' })
  }
  return result
}

export function recordTypeName(type) {
  const item = MATCHING_ORDER_RECORD_TYPES.find((option) => Number(option.value) === Number(type))
  return item ? item.label : `未知类型（${valueOrDash(type)}）`
}

export function recordTypeTag(type) {
  const value = Number(type)
  if ([7, 8, 9, 10, 12, 20].includes(value)) return 'success'
  if ([3, 5, 6, 11, 19].includes(value)) return 'danger'
  if ([13, 14, 15, 17, 18].includes(value)) return 'warning'
  return ''
}

export function recordSenderName(record) {
  if (!record) return '--'
  if ([14, 19].includes(Number(record.type))) return '平台客服'
  if (Number(record.handle_user_type) === 3 || Number(record.msg_sender_id) === 1000) return '系统/平台'
  return valueOrDash(record.msg_sender_short_name || record.msg_sender_family_name)
}

export function recordImages(record) {
  if (!record || !hasValue(record.record_img_urls)) return []
  return String(record.record_img_urls).split(',').map((url) => url.trim()).filter(Boolean)
}

export function formatTime(momentInstance, value) {
  if (!hasValue(value)) return '--'
  const numericValue = Number(value)
  const source = Number.isFinite(numericValue) ? numericValue : value
  const result = momentInstance(source)
  return result.isValid() ? result.format('YYYY-MM-DD HH:mm') : '--'
}
